module.exports = __webpack_public_path__ + "media/images/xpass/markers/active-selected/stride-92df8f3318d2c12cf09cd9c56f54ba46.png";